// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"665c26dd16fdc035","560":"eaa82dfa8008d52b"}[chunkId] + ".css";
};